import { CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import React, { useContext, useEffect } from "react";

import DataContext from "../../../../../../../../../context/DataContext";
import FollowUpModal from "../../../FollowUpModal";
import { FollowUpDispatchContext, FollowUpStateContext } from "../../context/FollowUpContext";
import useAPIFieldData from "../../hooks/useAPIFieldData";
import { setCaseInfo, setShouldFetchData } from "../../state/actions";

import FollowUpList from "./FollowUpList";
import Header from "./Header";
import NoAvailableFollowUps from "./NoAvailableFollowUps";

const FollowUpSection = ({ divId, actionType, caseInfo, title, actionTypeList }) => {
  const state = useContext(FollowUpStateContext);
  const dispatch = useContext(FollowUpDispatchContext);

  const { accessToken } = useContext(DataContext);
  const [fetchData] = useAPIFieldData(caseInfo.caseId, actionType, accessToken, dispatch, state);

  useEffect(() => {
    let active = true;
    if (active) {
      if (state && state.shouldFetchData && actionType) {
        fetchData();
      }
    }
    return () => {
      active = false;
    };
  }, [fetchData, state]);

  useEffect(() => {
    let active = true;
    if (active) {
      if (caseInfo.caseId) {
        setShouldFetchData(dispatch, true);
      }
    }
    return () => {
      active = false;
    };
  }, [dispatch, caseInfo.caseId]);

  useEffect(() => {
    let active = true;
    if (active) {
      if (caseInfo) {
        setCaseInfo(dispatch, caseInfo);
      }
    }
    return () => {
      active = false;
    };
  }, [dispatch, caseInfo]);

  return (
    <div id={divId} data-testid={divId}>
      <div className="m-2 mb-2">
        <Header id={"header-" + divId} title={title} showAddButton={state.showAddButton} />
        {!state.loading ? (
          state.data && state.data[actionType] ? (
            <FollowUpList
              listOfItems={
                actionType === actionTypeList?.provider?.key ? state.data[actionType] : state.data
              }
              label={
                actionType === actionTypeList?.provider?.key ? null : state.data[actionType].label
              }
              actionType={actionType}
              actionTypeList={actionTypeList}
            />
          ) : (
            <NoAvailableFollowUps divId={divId} />
          )
        ) : (
          <CircularProgress />
        )}
      </div>
      {state.showDialog && (
        <FollowUpModal
          divId={divId}
          title={title}
          actionType={actionType}
          state={state}
          dispatch={dispatch}
        />
      )}
    </div>
  );
};

FollowUpSection.propTypes = {
  divId: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.object,
  actionType: PropTypes.number,
  caseInfo: PropTypes.object,
};

export default FollowUpSection;
